export default __webpack_public_path__ + "static/media/Footpad's Belt of the Hidden Palace.c91b6b66.jpg";